import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';
import { Subject } from '../subject.model';
import { User } from '../user/user.model';

export class TeacherCertification {
  id?: string;
  user?: User;
  year?: number;
  teaching_subjects?: Subject[];
  description?: string;
  attachment?: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    this.id = json._id || json.id;
    this.user = new User(json.user);
    this.year = json.year;
    this.teaching_subjects = (json['teaching_subjects'] || []).map(
      (s: any) => new Subject(s)
    );
    this.description = json.description;
    this.attachment = json.attachment;
    this.createdAt = AppJsonDecoder.optDate(json.createdAt);
    this.updatedAt = AppJsonDecoder.optDate(json.updatedAt);
  }
}
